const Inbox = ({
  status = {
    read: false,
    favorited: false,
    archived: false,
    spam: false,
  },
} = {}) => ({
  status: Object(status),
});

export default Inbox;

export type InboxProps = ReturnType<typeof Inbox>;
